import React, { Component, Fragment } from 'react'
import * as PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import { Filter, ShowFilter } from 'components'
import i18n from 'support/i18n'
import NxtCircularLoader from 'components/nxt_circular_loader/View'
import { FIRST_LIMIT_CONSTANT, LIMIT_CONSTANT } from 'common_constants/Ideas'
import styles from './View.Style'
import ExploreFilterFields from '../explore/components/explore_filter_fields/View'
import SearchInput from '../explore/components/search_input/View'

export const INIT_FILTER = {
  status: [],
  challenge: {},
  organizations: [],
  types: [],
  attributes: [],
}

class PrivateIdeas extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeFilters: INIT_FILTER,
      offset: 0,
      search: '',
      showSlider: false,
      disableFilters: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleOnLoadMore = this.handleOnLoadMore.bind(this)
    this.handleActiveFilters = this.handleActiveFilters.bind(this)
    this.getIdeas = this.getIdeas.bind(this)
    this.handleResetSearchClick = this.handleResetSearchClick.bind(this)
  }

  componentDidMount() {
    this.getIdeas()
  }

  componentDidUpdate(prevProps) {
    const { domainLoaded, getActiveChallenges } = this.props
    if (domainLoaded && prevProps.domainLoaded !== domainLoaded) {
      getActiveChallenges()
    }
  }

  getIdeas(offset = 0) {
    const { getPrivateIdeas } = this.props
    const { activeFilters } = this.state
    const { challenge, status, organizations, types, attributes } = activeFilters

    getPrivateIdeas({
      challenge: challenge.id || null,
      organizations: organizations?.map(org => `${org.id}`),
      status: status?.map(statusItem => statusItem.id),
      types: types?.map(type => `${type.id}`),
      attributes: attributes?.map(attribute => `${attribute.id}`),
      offset,
    })
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      disableFilters: !!event.target.value,
    })
  }

  handleActiveFilters(newState) {
    this.setState({ ...newState, offset: 0 }, this.getIdeas)
  }

  handleFilter(value) {
    this.setState({ showSlider: value })
  }

  handleOnLoadMore() {
    const { offset } = this.state
    const newLimit = offset ? LIMIT_CONSTANT : FIRST_LIMIT_CONSTANT
    const newOffset = newLimit + offset
    this.getIdeas(newOffset)
    this.setState({ offset: newOffset })
  }

  handleResetSearchClick() {
    this.getIdeas()
    this.setState({ offset: 0 })
  }

  render() {
    const {
      getPrivateIdeas,
      applySearch,
      classes,
      challenges,
      statusList,
      getOrganization,
      getTypes,
      getAttributes,
      hasMoreIdeasToLoad,
      ideas,
      ideaStatusStepper,
      isOrganizationsActive,
      isTypesActive,
      isAttributesActive,
      navigateToIdeaDetail,
      organizationsName,
      organizations,
      totalIdeas,
      typesName,
      types,
      attributesName,
      attributes,
      isIdeasLoading,
      customIdeaTitles,
    } = this.props
    const { activeFilters, search, showSlider, disableFilters } = this.state

    return (
      <Fragment>
        <div className={classes.top}>
          <div className={classes.topCenter}>
            <h1 style={{ textTransform: 'capitalize' }}>
              <i className="icon-target" />{' '}
              {i18n.t('SCREEN.PRIVATE_IDEAS', { title: customIdeaTitles.pluralTitle || 'ideas' })}
            </h1>
          </div>
        </div>
        <div className={classes.middle}>
          <div className={classes.center}>
            <Filter className={classes.center}>
              <ExploreFilterFields
                activeFilters={activeFilters}
                applyFilter={getPrivateIdeas}
                challenges={challenges}
                challengeDetail={this.id}
                statusList={statusList}
                className={classes.gridCenter}
                getOrganization={getOrganization}
                getTypes={getTypes}
                getAttributes={getAttributes}
                organizationsName={organizationsName}
                organizations={organizations}
                typesName={typesName}
                types={types}
                attributesName={attributesName}
                attributes={attributes}
                isOrganizationsActive={isOrganizationsActive}
                isTypesActive={isTypesActive}
                isAttributesActive={isAttributesActive}
                handleActiveFilters={this.handleActiveFilters}
                disabled={disableFilters}
              />
            </Filter>
            <div className={classes.ideasFilter}>
              <SearchInput
                applySearch={applySearch}
                resetSearch={this.handleResetSearchClick}
                handleChange={this.handleChange}
                value={search}
              />
            </div>
            <NxtCircularLoader isLoading={isIdeasLoading}>
              <ShowFilter
                cards={ideas}
                showSlider={showSlider}
                onClick={navigateToIdeaDetail}
                onCardTypeChange={this.handleFilter}
                onLoadMore={this.handleOnLoadMore}
                totalIdeas={totalIdeas}
                showLoadMoreButton={hasMoreIdeasToLoad}
                ideaStatusStepper={ideaStatusStepper}
                showSmallCardCircle
                customIdeaTitles={customIdeaTitles}
              />
            </NxtCircularLoader>
          </div>
        </div>
      </Fragment>
    )
  }
}

PrivateIdeas.propTypes = {
  getPrivateIdeas: PropTypes.func.isRequired,
  navigateToIdeaDetail: PropTypes.func.isRequired,
  ideas: PropTypes.arrayOf(
    PropTypes.shape({
      challenged: PropTypes.bool,
      textWithoutTags: PropTypes.string,
      id: PropTypes.string,
      images: PropTypes.arrayOf(
        PropTypes.shape({
          bucket: PropTypes.string,
          key: PropTypes.string,
          name: PropTypes.string,
          size: PropTypes.number,
          url: PropTypes.string,
        }),
      ),
      investors: PropTypes.string,
      goal: PropTypes.string,
      pledged: PropTypes.string,
      profit: PropTypes.string,
      sponsored: PropTypes.bool,
      ownerName: PropTypes.string,
      title: PropTypes.string,
      created: PropTypes.number,
      countdownEnds: PropTypes.number,
      status: PropTypes.string,
    }),
  ).isRequired,
  isIdeasLoading: PropTypes.bool.isRequired,
  customIdeaTitles: PropTypes.shape({
    singularTitle: PropTypes.string,
    pluralTitle: PropTypes.string,
  }).isRequired,
}

export default withStyles(styles)(PrivateIdeas)
